/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.OMS {
    var x;
    @Serenity.Decorators.registerClass()
    export class TaxDetailsEditor extends Common.GridEditorBase<TaxDetailsRow> {
        protected getColumnsKey() { return "OMS.TaxDetails"; }
        protected getDialogType() { return TaxDetailsDialog; }
        protected getLocalTextPrefix() { return TaxDetailsRow.localTextPrefix; }
         
        protected form: TaxDetailsForm;

        
        constructor(container: JQuery) { 
            super(container); 


        }
        public DisableAddButton() {
            this.toolbar.element.hide();
            this.element.hide();
        }

        public EnableAddButton() {
            this.toolbar.element.show();
            this.element.show();
            


        } 
        
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }

        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.TaxSelectGrid;
            // grid.apply(this.rowSelection = new Serenity.GridRowSelectionMixin(this));
            //grid.apply(this.getColumns = (Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            
            buttons.push({
                title: "Select Tax",
                cssClass: "add-button",
                onClick: () => {
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.TaxId)
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.TaxId == t.Tax_Id) });
                        var taxdetails = [];
                        
                        selectedItems2.forEach(function (value) {


                            var txName = TaxRow.getLookup().itemById[value.TaxId].TaxName;
                            var TaxDetails: TaxDetailsRow = {
                                SelectedtaxId: value.TaxId,
                                TaxName: txName
                            };
                            taxdetails.push(TaxDetails);

                        });
                        
                        //alert('Length details' + taxdetails.length);
                        for (let taxDetail of taxdetails) {
                            taxDetail[this.getIdProperty()] = "`" + this.nextId++;
                            
                            
                            this.view.addItem(taxDetail);

                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });
            
            return buttons;
        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }/*
        validateEntity(row: TaxDetailsRow, id: number) {
            if (!super.validateEntity(row, id))
                return false;


            //duplicate Component
            row.Product_Bom_Id = Q.toId(row.Product_Bom_Id);

            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.Product_Bom_Id === row.Product_Bom_Id);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Component is already in product details!');
               return false;
            }

             //update values in grid

            row.Product_Code = ProductMasterRow.getLookup().itemById[row.Product_Bom_Id].Product_Code;
            row.FixedName = FixedCodeRow.getLookup().itemById[row.Calculate_On].FixedName;
            row.Attribute = CommonAttributesRow.getLookup().itemById[row.Attribute_Id].Attribute;
            row.ItemType = CommonAttributesRow.getLookup().itemById[row.Attribute_Id].ItemType;
            return true;
        } */   

    }
}